import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "org-map-node" }
const _hoisted_2 = { class: "children" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NodeCard = _resolveComponent("NodeCard")
  const _component_Node = _resolveComponent("Node", true)
  const _component_Collapse = _resolveComponent("Collapse")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_NodeCard, {
      node: $props.node,
      expanded: $data.expanded,
      onToggle: $options.toggle
    }, null, 8 /* PROPS */, ["node", "expanded", "onToggle"]),
    ($options.has_children)
      ? (_openBlock(), _createBlock(_component_Collapse, {
          key: 0,
          open: $data.expanded
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.node.children, (child, idx) => {
                return (_openBlock(), _createBlock(_component_Node, {
                  key: `${$props.node.name}-${idx}`,
                  node: child
                }, null, 8 /* PROPS */, ["node"]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["open"]))
      : _createCommentVNode("v-if", true)
  ]))
}